const DATA = [
    {
        title: "池上地震導致的損失",
        details: [
            "損失類型",
            "停水時間長與損失",
            "停電時間長與損失",
            "建物損失"
        ]
    },
    {
        title: "遇到池上地震！民眾都做了什麼？",
        details: [
            "地震時在哪個縣市鄉鎮",
            "地震時在室內、室外還是交通工具上",
            "地震了！民眾立即的反應",
            "地震後的避難行為\n（是否避難、避難地點、避難時間長）"
        ]
    },
    {
        title: "受訪者及家戶特徵",
        details: [
            "家戶特徵\n（人口組成、身心障礙者與、家戶收入等...）",
            "受訪者特徵\n（性別、年齡、教育程度、原住民與否）"
        ]
    },
    {
        title: "民眾日常的減災整備",
        details: [
            "避難知識的來源",
            "是否知道防災手冊",
            "住宅安全的主觀認知",
            "是否知道趴下、掩護、穩住",
            "是否和家人討論如何避難",
            "可接受之避難處距離",
            "是否準備防災包／不準備的理由",
            "是否固定家具",
            "是否加強住宅結構",
            "是否規劃避難路線",
            "是否參與地震應變演練",
            "是否購買住宅地震保險"
        ]
    }
]

export default DATA;